/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './module';
export * from './select';
export * from './select-animations';



// WEBPACK FOOTER //
// ../../../../../src/material/select/public-api.ts